import React from 'react';
import { Card, CardHead, BarRow, Pill } from '../components/UI';
import s from './Workflow.module.css';

const STEPS = [
  { status:'done', label:'Supplier submission', sub:'Invoice + 4 docs attached', time:'30 Jun, 09:14' },
  { status:'done', label:'AI validation', sub:'Score 81/100 — passed', time:'30 Jun, 09:16' },
  { status:'done', label:'Procurement review', sub:'Approved by V. Krishnan', time:'01 Jul, 11:30' },
  { status:'active', label:'Operations review', sub:'Assigned to R. Subramanian', time:'In progress' },
  { status:'wait', label:'Finance approval', sub:'Awaiting ops clearance', time:'—' },
  { status:'wait', label:'CFO authorisation', sub:'Final sign-off', time:'—' },
  { status:'wait', label:'Payment cleared', sub:'Bank instruction triggered', time:'—' },
];

const QUEUE = [
  { inv:'INV-1179', supplier:'Tamil Agro Fuels', amount:'₹11 L', stage:'review', stageLabel:'Ops review', sla:'1d left', slaColor:'var(--warn)' },
  { inv:'INV-1176', supplier:'SunTech Lubricants', amount:'₹7.5 L', stage:'new', stageLabel:'Finance', sla:'3d left', slaColor:'var(--accent)' },
  { inv:'INV-1174', supplier:'Deccan Petroleum', amount:'₹22 L', stage:'new', stageLabel:'CFO', sla:'2d left', slaColor:'var(--accent)' },
  { inv:'INV-1172', supplier:'Bharat Petro', amount:'₹9.1 L', stage:'review', stageLabel:'Procurement', sla:'Overdue', slaColor:'var(--danger)' },
];

export default function Workflow() {
  const dotClass = { done: s.dotDone, active: s.dotActive, wait: s.dotWait };
  const dotIcon = { done: '✔', active: '→', wait: '○' };

  return (
    <div className={s.grid}>
      <Card>
        <CardHead title="INV-2024-1179 — Tamil Agro Fuels" />
        <div className={s.invAmount}>
          <div className={s.flab}>Amount</div>
          <div className={s.fval}>₹11,00,000</div>
        </div>
        <div className={s.steps}>
          {STEPS.map((step, i) => (
            <div key={i} className={`${s.wstep} ${i < STEPS.length-1 ? s.wstepLine : ''}`}>
              <div className={`${s.wdot} ${dotClass[step.status]}`}>{dotIcon[step.status]}</div>
              <div className={s.winfo}>
                <div className={s.wname}>{step.label}</div>
                <div className={s.wsub}>{step.sub}</div>
              </div>
              <div className={s.wtime}>{step.time}</div>
            </div>
          ))}
        </div>
      </Card>

      <div>
        <Card style={{marginBottom:12}}>
          <CardHead title="All invoices — approval queue" />
          <table className={s.table}>
            <thead>
              <tr><th>Invoice</th><th>Supplier</th><th>Amount</th><th>Stage</th><th>SLA</th></tr>
            </thead>
            <tbody>
              {QUEUE.map(q => (
                <tr key={q.inv}>
                  <td style={{color:'var(--info)'}}>{q.inv}</td>
                  <td>{q.supplier}</td>
                  <td>{q.amount}</td>
                  <td><Pill type={q.stage}>{q.stageLabel}</Pill></td>
                  <td style={{color:q.slaColor,fontSize:11,fontWeight:500}}>{q.sla}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>

        <Card>
          <CardHead title="Workflow analytics" />
          <BarRow label="Supplier → AI" fillPct={8} fillColor="var(--accent)" value="2 min" />
          <BarRow label="AI → Procurement" fillPct={55} fillColor="var(--info)" value="1.2 d" />
          <BarRow label="Procurement → Ops" fillPct={30} fillColor="var(--warn)" value="0.7 d" />
          <BarRow label="Ops → Finance" fillPct={40} fillColor="#534AB7" value="0.9 d" />
          <BarRow label="Finance → CFO" fillPct={18} fillColor="var(--accent)" value="0.4 d" />
        </Card>
      </div>
    </div>
  );
}
